import React from 'react';
import { withRouter } from 'react-router-dom';
import DataGrid from '../../table/datagrid.component';
import Summary from '../../summary/summary.component';
import { usaColumns } from '../../../utils/grid.utils';
import Insight from '../../insight/insight.component';
import { sortObjectArrayDesc } from '../../../utils/helper';
import Timeline from './../../timeline/timeline.component';

const CountryDashboard = (props) => {
  const { dashboarddata, time, match } = props;
  const countryParam = match.params.countrycode;
  const stateParam = match.params.statecode;
  const data = [...dashboarddata];
  const f = data.filter(country => country.id === countryParam);
  let insightData = f[0].areas;

  if (stateParam) {
    const s = insightData.filter(country => country.id === stateParam);
    insightData = s[0].areas;
  }

  let isRowClickable = false;
  if (insightData && insightData.length > 0) {
    isRowClickable = true;
  }
  return (
    <div className="datagrid">
      <Summary title={`${f[0].displayName}`} summarydata={f[0]} time={time} />
      <Timeline refCode={f[0].countryCode} />
      <Insight
        topConfirmed={sortObjectArrayDesc(insightData, 'totalConfirmed', 3)}
        topDeaths={sortObjectArrayDesc(insightData, 'totalDeaths', 3)}
        topRecovered={sortObjectArrayDesc(insightData, 'totalRecovered', 3)} />
      <DataGrid isState isRowClickable={isRowClickable} title="Dashboard" columns={usaColumns} data={insightData} />
    </div>
  );
}

export default withRouter(CountryDashboard);